import React from 'react';
import { Control, ControllerProps, useController, useFormContext } from 'react-hook-form';
import { FormControlLabel, FormControlLabelProps } from '@material-ui/core';
import FormHelperText from '@material-ui/core/FormHelperText';

import { CheckboxField, CheckboxFieldProps } from 'shared/forms/CheckboxField';

export type ControlledCheckboxFieldProps = Pick<ControllerProps, 'name' | 'rules' | 'defaultValue'> &
  Omit<FormControlLabelProps, 'label' | 'control'> & {
    control?: Control;
    checkboxFieldProps?: CheckboxFieldProps;
    label?: FormControlLabelProps['label'];
  };

export const ControlledCheckboxField = ({
  defaultValue,
  name,
  control,
  rules,
  label,
  checkboxFieldProps,
  ...props
}: ControlledCheckboxFieldProps) => {
  const { control: formControl, setError } = useFormContext() ?? {};

  const {
    field: { onChange, value, ref },
    fieldState: { error },
  } = useController({
    name: name,
    defaultValue,
    rules,
    control: control ?? formControl,
  });

  const handleChange = (e: React.ChangeEvent<Record<string, unknown>>, checked: boolean) => {
    if (error?.message && typeof setError === 'function') setError(name, { message: '' });
    props.onChange && props.onChange(e, checked);
    onChange(e);
  };

  return (
    <>
      <FormControlLabel
        {...props}
        ref={ref}
        checked={value}
        value={value}
        onChange={handleChange}
        control={<CheckboxField {...checkboxFieldProps} />}
        label={label}
      />
      {error && <FormHelperText error>{error.message}</FormHelperText>}
    </>
  );
};
